// hooks/useReadFeedbacks.ts
import { useState, useCallback } from 'react';

interface UserFeedback {
  id: number;
  userId: number;
  feedbackType: "note" | "probleme";
  note: number | null;
  commentaire: string | null;
  problemeType: string | null;
  message: string | null;
  dateCreated: Date;
  suiviStatus: "non_traité" | "en_cours" | "résolu" | null;
  suiviCommentaire: string | null;
  dateTreated: Date | null;
  lu: boolean;
}

export function useReadFeedbacks() {
  const [feedbacks, setFeedbacks] = useState<UserFeedback[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const loadFeedbacks = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await fetch('/api/ReadFeedback');
      
      if (!response.ok) {
        throw new Error('Erreur lors du chargement des réponses');
      }
      
      const data = await response.json();
      
      if (Array.isArray(data)) {
        setFeedbacks(data);
      } else {
        console.error('La réponse de l\'API n\'est pas un tableau:', data);
        setFeedbacks([]);
        setError('Format de réponse incorrect');
      }
    } catch (err: any) {
      console.error('Erreur loadReadFeedbacks:', err);
      setError(err.message || 'Erreur inconnue');
      setFeedbacks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    feedbacks,
    loading,
    error,
    loadFeedbacks,
    setFeedbacks, // Au cas où vous voulez manipuler l'état directement
  };
}